var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14775",
    "data-name": "Group 14775",
    transform: "translate(-1128 -185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4548",
    "data-name": "Rectangle 4548",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(1128 185)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35674",
    "data-name": "Path 35674",
    d: "M1148.69,199.917a1,1,0,0,1-1.38,0l-.69-.664A4.5,4.5,0,0,0,1139,202.5a7.951,7.951,0,0,0,3.15,5.967,20.561,20.561,0,0,0,5.42,3.238,1.115,1.115,0,0,0,.86,0,20.561,20.561,0,0,0,5.42-3.238A7.951,7.951,0,0,0,1157,202.5a4.5,4.5,0,0,0-7.62-3.247Zm-.69-2.107a6.5,6.5,0,0,0-11,4.69c0,6.368,6.97,9.885,9.81,11.055a3.115,3.115,0,0,0,2.38,0c2.84-1.17,9.81-4.687,9.81-11.055a6.5,6.5,0,0,0-11-4.69Z",
    fill: "#777e91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4549",
    "data-name": "Rectangle 4549",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(1129 186)",
    fill: "none",
    stroke: "#e6e8ec",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.2975df4c92345d86a52ceb82de2ecc8a.svg";
export { ForwardRef as ReactComponent };